export default "__VITE_ASSET__LTimf_9s__"